import { HolidayDto } from './holiday-dto.model';


export class HolidayApplicationDto implements IHolidayApplicationDto {
    id!: number;
    fromDate!: Date;
    toDate!: Date;
    holiday!: HolidayDto;
    isPaid!: boolean;

    constructor(data?: IHolidayApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.holiday = _data["holiday"] ? HolidayDto.fromJS(_data["holiday"]) : <any>undefined;
            this.isPaid = _data["isPaid"];
        }
    }

    static fromJS(data: any): HolidayApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["holiday"] = this.holiday ? this.holiday.toJSON() : <any>undefined;
        data["isPaid"] = this.isPaid;
        return data; 
    }
}

export interface IHolidayApplicationDto {
    id: number;
    fromDate: Date;
    toDate: Date;
    holiday: HolidayDto;
    isPaid: boolean;
}

